import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export type WorkflowStage =
    | 'customer-auth'
    | 'plan-selection'
    | 'application'
    | 'submitting'
    | 'decision'
    | 'accept-offer'
    | 'update-offer'
    | 'signing'
    | 'external-application'
    | 'second-look-application'
    | 'second-look-applicant-information'
    | 'second-look-submitting'
    | 'second-look-decision'
    | 'application-with-co-application'
    | 'reset'
    | 'reviewing'
    | 'transition-to-hard-app';

function useWorkflow(initialState: WorkflowStage) {
    const [workflowStage, setWorkflowStage] = useState(initialState);

    return { workflowStage, setWorkflowStage };
}

export const WorkflowStore = createStore(useWorkflow);

export type WorkflowStore = ReturnType<typeof useWorkflow>;
